"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.waitFor = void 0;
/**
 * Normalises a promise that errors into an awaitable [result, error] array.
 *
 * @param promise The resolveable promise
 */
exports.waitFor = (promise) => __awaiter(void 0, void 0, void 0, function* () {
    return promise.then((result) => {
        return [result, null];
    }).catch((e) => {
        return [null, e];
    });
});
//# sourceMappingURL=wait-for.js.map